import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import {type Department} from 'web-app/react/institution/settings/edit-group/models';

import type * as Models from './models';
import * as Actions from './actions';

export class EditGroupState extends Record<{
    readonly departments?: Department[];
    readonly groupSettings?: Models.GroupSetting[];
    readonly group?: Models.GroupFromAPI;
    readonly loading: boolean;
    readonly loadingSettings: boolean;
    readonly loadingDepartments: boolean;
    readonly updatingGroup: boolean;
    readonly updatingGroupSettings: boolean;
    readonly deleting: boolean;
}>({
    deleting: false,
    departments: undefined,
    groupSettings: undefined,
    group: undefined,
    loading: false,
    loadingDepartments: false,
    loadingSettings: false,
    updatingGroup: false,
    updatingGroupSettings: false,
}) {}

export default makeReducer<EditGroupState>(
    [
        match(Actions.fetchGroup, (state, {payload}) =>
            payload.shouldReset
                ? new EditGroupState({
                      loading: true,
                  })
                : state.merge({
                      loading: true,
                  }),
        ),
        match(Actions.fetchGroupSuccess, (state, {payload}) =>
            state.merge({
                loading: false,
                group: payload.group,
            }),
        ),
        match(Actions.fetchGroupFailed, state =>
            state.merge({
                loading: false,
            }),
        ),
        match(Actions.updateGroup, state =>
            state.merge({
                updatingGroup: true,
            }),
        ),
        match(Actions.updateGroupSuccess, state =>
            state.merge({
                updatingGroup: false,
            }),
        ),
        match(Actions.updateGroupFailed, state =>
            state.merge({
                updatingGroup: false,
            }),
        ),
        match(Actions.fetchGroupSettings, state =>
            state.merge({
                loadingSettings: true,
            }),
        ),
        match(Actions.fetchGroupSettingsSuccess, (state, {payload}) =>
            state.merge({
                loadingSettings: false,
                groupSettings: payload.settings,
            }),
        ),
        match(Actions.fetchGroupSettingsFailed, state =>
            state.merge({
                loadingSettings: false,
            }),
        ),
        match(Actions.updateGroupSetting, state =>
            state.merge({
                updatingGroupSettings: true,
            }),
        ),
        match(Actions.updateGroupSettingSuccess, state =>
            state.merge({
                updatingGroupSettings: false,
            }),
        ),
        match(Actions.updateGroupSettingFailed, state =>
            state.merge({
                updatingGroupSettings: false,
            }),
        ),
        match(Actions.fetchDepartments, state =>
            state.merge({
                loadingDepartments: true,
            }),
        ),
        match(Actions.fetchDepartmentsSuccess, (state, {payload}) =>
            state.merge({
                loadingDepartments: false,
                departments: payload.departments,
            }),
        ),
        match(Actions.fetchDepartmentsFailed, state =>
            state.merge({
                loadingDepartments: false,
            }),
        ),
    ],
    new EditGroupState(),
);
